// extracted by mini-css-extract-plugin
export default {"header":"header_header__TpZ42","leftSide":"header_leftSide__cICEE","rightSide":"header_rightSide__5vNYA"};